import { render, staticRenderFns } from "./Chat.Message.vue?vue&type=template&id=3b337f42&"
import script from "YD/components/chat/chat.component.roomMessage.js?vue&type=script&lang=js&"
export * from "YD/components/chat/chat.component.roomMessage.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports